import axios from "axios";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../../axios";
import { Loading } from "../../Other/Loading";

const Forms = ({ setModal, title, role, editData }) => {
  const [formValue, setFormValue] = useState({
    page_name: editData.page_name ? editData.page_name : "",
    page_slug: editData.page_slug ? editData.page_slug : "",
    is_active: editData.is_active ? editData.is_active : false,
  });

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState({});
  const [load, setLoad] = useState(false);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormValue((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validate = () => {
    let error = {};
    if (!formValue.page_name) {
      error.page_name = "Please enter Page name";
    }
    if (!formValue.page_slug) {
      error.page_slug = "Please enter Page slug";
    }
    if (!formValue.is_active) {
      error.is_active = "Please select if the page is active";
    }
    setError(error);
    return Object.keys(error).length === 0;
  };

  const handleSubmit = async () => {
    setLoad(true);
    if (validate()) {
      const url = editData.id ? "/admin/edit/page" : "/admin/add/page";
      const data = {
        id: editData.id,
        page_name: formValue.page_name,
        page_slug: formValue.page_slug,
        is_active: formValue.is_active,
      };

      try {
        const res = await axiosInstance.post("/page/add", data);
        // handle response here if needed
      } catch (err) {
        console.error("Error submitting page:", err);
      } finally {
        setLoad(false);
      }
    } else {
      setLoad(false);
    }
  };


  return (
    <div className="forms-width-55 add-page">
      <div className="dashboard-container-new padding-custom-dashboard-0">
        <p>{editData?.id ? `Edit ${title}` : `Add New ${title}`}</p>
      </div>
      <div className="form-content">
        {!success && (
          <>
            <div className="border-bottom-new-0">
              <p className="basic-form-01">Page Information</p>
            </div>
            <div className="dashboard-main my-3">
              <label className="labels-form w-[20%]">Page Name*</label>
              <div className="w-[100%] mx-auto">
                <input
                  className="inputs-form  mx-auto"
                  name="page_name"
                  value={formValue.page_name}
                  onChange={handleChange}
                />
                <div>
                  {error?.page_name && (
                    <span className="error-text-new text-center">{error?.page_name}</span>
                  )}
                </div>
              </div>
            </div>
            <div className="dashboard-main my-3">
              <label className="labels-form w-[20%]">Page Slug*</label>
              <div className="w-[100%] mx-auto">
                <input
                  className="inputs-form"
                  name="page_slug"
                  value={formValue.page_slug}
                  onChange={handleChange}
                />
                {error?.page_slug && (
                  <span className="error-text-new">{error?.page_slug}</span>
                )}
              </div>
            </div>
            <div className="dashboard-main">
              <div className="radio">
                <input
                  type="checkbox"
                  className="cb"
                  id="is_active"
                  name="is_active"
                  checked={formValue.is_active}
                  onChange={handleChange}
                />
                <label htmlFor="is_active" className="label-data">
                  Active
                </label>
              </div>
            </div>
            <div className="dashboard-main justify-flex-new">
              <div className="margin-top-new-01-0">
                {load ? (
                  <Loading />
                ) : (
                  <button className="export-btn" onClick={handleSubmit}>
                    {editData?.id ? "Update" : "Submit"}
                  </button>
                )}
              </div>
              <div className="margin-top-new-01-0">
                <button
                  className="lastmonth-btn-0"
                  onClick={() => setModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </>
        )}
        {success && (
          <div className="alert-title">
            <div className="status-message">
              <div className="status-title">
                <p>
                  {editData.id
                    ? `${title} has been successfully updated`
                    : `${title} has been successfully added`}
                </p>
              </div>
            </div>
            <div className="margin-top-new-01-0">
              <button
                className="lastmonth-btn-0"
                onClick={() => setModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Forms;